import { homeService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest } from "@miplatform/types";
import { CreateBidRequestApiPayload } from "../../views/Estimating/Bids/CreateBidRequest/CreateBidRequest.type";

export const useBidRequests = () => {
  const stateManager = useComponentState();

  const getBidRequests = ({
    top,
    skip,
    filters,
    sort = "dueDate asc",
  }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      return homeService.bidRequests.getAll({ top, skip, filters, sort });
    });
  };

  const createBidRequest = async (
    data: CreateBidRequestApiPayload,
    successText?: string
  ) => {
    return stateManager.run(async () => {
      return homeService.bidRequests.create({
        data,
        toastMessageConfig: {
          success: {
            text: successText || "Bid request was created successfully.",
          },
        },
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    getBidRequests,
    createBidRequest,
  };
};
